<template>
  <div
    class="c-outage-result__unplanned"
    :class="{
      'c-outage-result__unplanned--list-view': outagePageView === 'list',
    }"
  >
    <div class="c-outage-result__unplanned-triangle"></div>
    <div class="c-outage-result__wrapper">
      <img class="c-outage-result__graphic" :src="getMarkerIcon(outage)" />
      <div class="c-outage-result__details">
        <p class="c-outage-result__outage-number">{{ "#" + outage.id }}</p>
        <h3 class="c-outage-result__outage-title">
          <a :href="outage.link">
            {{ outage.suburbsText }}
          </a>
        </h3>

        <p class="c-outage-result__outage-type">Unplanned outage</p>

        <template v-if="filterOption == 'current'">
          <p class="c-outage-result__start-time">
            Start date/time:
            <span class="c-outage-result__bold">{{
              formatDate(outage.timeOfFault)
            }}</span>
          </p>
          <p class="c-outage-result__start-time">
            Estimated restoration:
            <span class="c-outage-result__bold">{{
              formatDate(outage.lastUpdatedEta)
            }}</span>
          </p>
          <template v-if="outage.lastUpdatedCustomersAffected > 0">
            <p class="c-outage-result__update">
              We have {{ outage.lastUpdatedCustomersAffected }} affected
              customers
              <template v-if="outage.lastUpdatedEta">
                and expect to restore power
                {{ timeFromNoFuture(outage.lastUpdatedEta) }}
              </template>
              <template v-else>
                . Estimated time of restoration to be confirmed
              </template>
            </p>
          </template>
          <template v-else>
            <p v-if="outage.lastUpdatedEta" class="c-outage-result__update">
              We expect to restore power
              {{ timeFromNoFuture(outage.lastUpdatedEta) }}
            </p>
            <p v-else class="c-outage-result__update">
              Estimated time of restoration to be confirmed
            </p>
          </template>
        </template>
        <template v-if="filterOption == 'recent'">
          <p class="c-outage-result__start-time">
            Start date/time:
            <span class="c-outage-result__bold">{{
              formatDate(outage.timeOfFault)
            }}</span>
          </p>
          <p class="c-outage-result__end-time">
            End date/time:
            <span class="c-outage-result__bold">{{
              formatDate(outage.lastUpdatedTime)
            }}</span>
          </p>
        </template>

        <p class="c-outage-result__last-updated">
          Updated {{ timeFrom(outage.lastUpdatedTime) }}
        </p>
        <a :href="outage.link" class="c-outage-result__link"
          >More details<span>
            <img
              :src="'_resources/app/client/assets/icons/outages-map/more-details-arrow.svg'"
            /> </span
        ></a>
        <span
          v-if="outagePageView == 'map'"
          @click="zoomToMap(outage)"
          class="c-outage-result__zoom"
        >
          <img :src="'_resources/app/client/assets/icons/outages-map/map-icon.svg'" />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import { eventBus } from "../utils/event-bus.js";

export default {
  props: {
    outage: Object,
  },
  created() {},
  components: {},
  mounted() {},
  computed: {
    ...mapFields(["filterOption", "outagePageView"]),
    ...mapGetters(["getMarkerIcon"]),
  },
  methods: {
    zoomToMap(outage) {
      eventBus.$emit("gmap-pan-to", outage.location);
    },
  },
};
</script>

<style lang="scss"></style>
